import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

/**
 * Hook to detect if the current viewport is mobile.
 * Uses Material UI's breakpoint system if available, or falls back to window width.
 * Standard breakpoint: 'sm' (600px) or 'md' (900px) depending on need.
 * For this dashboard, we consider anything below 'md' (900px) as mobile/tablet view
 * because of the complex tables.
 */
const useMobile = () => {
  const theme = useTheme()
  // Matches screen widths less than 900px (md)
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return isMobile
}

export default useMobile
